/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_1_DescInputs */

const es_home_intro_step_1_desc = /** @type {(inputs: Home_Intro_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincula tus fuentes de trabajo (Google Workspace, Microsoft 365, Dropbox) en minutos.`)
};

const en_home_intro_step_1_desc = /** @type {(inputs: Home_Intro_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your work sources (Google Workspace, Microsoft 365, Dropbox) in minutes.`)
};

/**
* | output |
* | --- |
* | "Link your work sources (Google Workspace, Microsoft 365, Dropbox) in minutes." |
*
* @param {Home_Intro_Step_1_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_1_desc = /** @type {((inputs?: Home_Intro_Step_1_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_1_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_1_desc(inputs)
	return en_home_intro_step_1_desc(inputs)
});
export { home_intro_step_1_desc as "home.intro.step_1_desc" }